import Resource from './Resource'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class ValuableConceptResource extends Resource {
    async allValuableConcepts(labId, valuableType) {
        let params = {
            valuableType: valuableType
        }
        const response = await this.axios.get(`/laboratories/${labId}/allValuableConcepts`, { params })
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
    async findValuableConceptsBySample(labId, caseId, sampleId, valuableType) {
        let params = {
            valuableType: valuableType
        }
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/valuableConcepts`, { params })
        return response.data
    }
    async findValuableConceptAppliedByCase(labId, caseId, valuableType) {
        let params = {
            valuableType: valuableType
        }
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/valuableConcepts`, { params })
        return response.data
    }
    async findSampleValuableConceptByModel(labId, caseId, sampleId, valuableType, valuableModelType) {
        let params = {
            valuableType: valuableType,
            valuableModelType: valuableModelType
        }
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/valuableConceptsByModel`, { params })
        return response.data
    }
    async findUCLValuableConceptAppliedByCase(labId, caseId) {
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/valuableConceptsUCL`)
        return response.data
    }
    async findURVValuableConceptAppliedByCase(labId, caseId) {
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/valuableConceptsURV`)
        return response.data
    }
}
export default new ValuableConceptResource()
